export const typesActivities = [
    { id: "1e4ebb51-5155-4a64-8d20-892285251e21", label: "Nivel", deppendOf:[] },
    { id: "90d6d4db-d8e2-436d-9385-4ffad7e80aa2", label: "Carta", deppendOf:[] },
    { id: "462b2733-9bc7-4ffe-a3e6-c7eb1516fc22", label: "Reespaceo", deppendOf:["brakeStatus","selectorStatus"] },
    { id: "e377cb89-3cf0-422f-a05b-a17f73187544", label: "Prueba Presión", deppendOf:["brakeStatus","secondFourthValveStatus","selectorStatus"] },
    { id: "8a8c2c05-d3b1-410c-bb3e-a8fd717f0e86", label: "Prueba de Válvula", deppendOf:["brakeStatus","selectorStatus"] },
];

export const typesVariables = [
    { id: "1", label: "Up", validationType:['Numeric'] },
    { id: "2", label: "Down",validationType:['Numeric'] },
    { id: "3", label: "Average",validationType:['Numeric','String'] },
];

export const statusConditions:any = [
    { name: "Frenos", field: "brakeStatus", correctStatus: ["OK"], warningStatus: ["Malos"] },
    { name: "Válvula Toma Muestra", field: "sampleValveStatus", correctStatus: ["OK"], warningStatus: ["Dañada"] },
    { name: "Fosa", field: "pitStatus", correctStatus: ["OK"], warningStatus: ["Achicar","Llena de Sedimentos"] },
    { name: "Válvula 2da de 4ta", field: "secondFourthValveStatus", correctStatus: ["OK"], warningStatus: ["Dañada","Enterrada","Sin Volante"] },
    { name: "Selector", field: "selectorStatus", correctStatus: ["Si"], warningStatus: ["Malo","No"] },
    { name: "Sonolog", field: "sonologStatus", correctStatus: ["OK"], warningStatus: ["Dañada","Enterrada","Petrolizada","Sin Facilidad","Sumergida","Toma Clandestina"] },
    { name: "Stuffing", field: "stuffingStatus", correctStatus: ["OK"], warningStatus: ["Empacar"] },
    { name: "Maleza", field: "weedStatus", correctStatus: ["OK"], warningStatus: ["Arrancador","Cabezal","Unidad"] },
];
